import { createContext } from 'react';

const DatagridContext = createContext({});

DatagridContext.displayName = 'DatagridContext';


export default DatagridContext;
